import { getOrgsDetails, getOrgCDocs } from "../../../services/httpCalls"

export const showDocsAlreadyUploaded = async ({
    setShowLoader,
    setCompanyType,
    setSelectionValue,
    setAlreadyuploaded,
    setUploadedFileList,
    setUploadedFileLinks,
}) => {

    let docsList = {
        COMPANY_PAN_CARD: false,
        SOLE_PROPRIETER_AADHAR_CARD: false,
        GST_CERTIFICATE: false,

    }

    let CompanyPan = []
    let CompanyGst = []
    let SoleProp = []

    setShowLoader(true)

    let orgId = localStorage.getItem("orgId")
    let uploadedFiles_ = {
        COMPANY_PAN_CARD: "",
        GST_CERTIFICATE: "",
        SOLE_PROPRIETER_AADHAR_CARD: "",

    }
    let uploadedFilesLinks_ = {
        COMPANY_PAN_CARD: "",
        GST_CERTIFICATE: "",
        SOLE_PROPRIETER_AADHAR_CARD: "",

    }
    try {
        await getOrgsDetails(orgId).then(res => {
            let orgsDetail = res
            if (orgsDetail) {
                if (res?.isOptInward && res?.isOptOutward) {
                    setSelectionValue("both")
                } else if (res?.isOptInward && !res?.isOptOutward) {
                    setSelectionValue("inward")
                } else {
                    setSelectionValue("outward")
                }
                // orgsDetail = JSON.parse(orgsDetail)
                setCompanyType(orgsDetail?.companyType)
            }
        })
        // await probDocsCheck(orgId)
        await getOrgCDocs(orgId)
            .then(res => {
                if (res.length) {
                    res?.map((val) => {
                        if (val.type === "COMPANY_PAN_CARD") {
                            docsList["COMPANY_PAN_CARD"] = true
                            // uploadedFiles_['COMPANY_PAN_CARD'] = val?.name?.split(`~~`)[1]
                            CompanyPan.push(val)
                        }

                        if (val.type === "GST_CERTIFICATE") {
                            docsList["GST_CERTIFICATE"] = true
                            // uploadedFiles_['GST_CERTIFICATE'] = val?.name?.split(`~~`)[1]
                            CompanyGst.push(val)
                        }
                        if (val.type === "SOLE_PROPRIETER_AADHAR_CARD") {
                            docsList["SOLE_PROPRIETER_AADHAR_CARD"] = true
                            // uploadedFiles_['MOA'] = val?.name?.split(`~~`)[1]
                            SoleProp.push(val)
                        }

                    })
                    let latestCompanyPanObject = CompanyPan?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )
                    let latestSolePropObject = SoleProp?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )

                    let latestCompanyGstObject = CompanyGst?.reduce(
                        (a, b) =>
                            new Date(a?.creationTime) > new Date(b?.creationTime) ? a : b,
                        {}
                    )



                    uploadedFiles_[
                        "COMPANY_PAN_CARD"
                    ] = latestCompanyPanObject?.name?.split(`~~`)[1]
                            ? latestCompanyPanObject?.name?.split(`~~`)[1]
                            : "";

                    uploadedFiles_[
                        "GST_CERTIFICATE"
                    ] = latestCompanyGstObject?.name?.split(`~~`)[1]
                            ? latestCompanyGstObject?.name?.split(`~~`)[1]
                            : "";

                    uploadedFiles_[
                        "SOLE_PROPRIETER_AADHAR_CARD"
                    ] = latestSolePropObject?.name?.split(`~~`)[1]
                            ? latestSolePropObject?.name?.split(`~~`)[1]
                            : "";

                    uploadedFilesLinks_[
                        "SOLE_PROPRIETER_AADHAR_CARD"
                    ] = latestSolePropObject?.s3Url?.split("amazonaws.com/")[1]
                            ? latestSolePropObject?.s3Url?.split("amazonaws.com/")[1]
                            : "";
                    uploadedFilesLinks_[
                        "GST_CERTIFICATE"
                    ] = latestCompanyGstObject?.s3Url?.split("amazonaws.com/")[1]
                            ? latestCompanyGstObject?.s3Url?.split("amazonaws.com/")[1]
                            : "";
                    uploadedFilesLinks_[
                        "COMPANY_PAN_CARD"
                    ] = latestCompanyPanObject?.s3Url?.split("amazonaws.com/")[1]
                            ? latestCompanyPanObject?.s3Url?.split("amazonaws.com/")[1]
                            : "";

                    setUploadedFileList(uploadedFiles_)
                    setAlreadyuploaded(docsList)
                    setUploadedFileLinks(uploadedFilesLinks_)
                }
            })
            .catch(err => console.log(err))
            .finally(() => setShowLoader(false))
    } catch {
        console.log("err")
    }
}